import { useTranslation } from 'react-i18next';
import React, { useState, Fragment, useRef } from 'react';
import { useNavigate, } from "react-router-dom";
import MasterStamm from "../MasterStammComponent/MasterStamm";
import DetailsBox from "../shared/components/DetailsBox";
import { Typography, Button, Box, MenuItem, TextField, Table, Grid } from "@mui/material";
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import { Mitarbeiterauswahl } from '../lib';
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import { DateTextField } from "../lib";
import InputBox from '../shared/components/InputBox';
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import openFile from "../shared/functions/download";
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import DynamicTable from "../shared/components/DynamicTableComponent";
function HRRessourcen(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { accessToken, client, } = props;
  const [open, setOpen] = useState(false);
  const [iboxtitle, setIBoxTitle] = useState("")
  const [openibox, setOpenIBox] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [rueckgabe, setRueckgabe] = useState(false);
  const [stamm, setStamm] = useState([]);
  const zeilenauswahl = useRef("");
  const spaltenauswahl = useRef("");
  const [mitarbeiter, setMitarbeiter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const [zuorddat, setZuordDat] = useState("");
  const [fragen, setFragen] = useState([]);
  const [msgbox, setMsgBox] = useState(false);
  const [auswahl, setAuswahl] = useState("");
  const [ansichtstatus, setAnsichtstatus] = useState("");
  const [briefvorlage, setBriefvorlage] = useState("");
  const [spin, setSpin] = useState(false);
  const [nurbottons, setNurButtons] = useState("");
  const [besitzer, setBesitzer] = useState([]);
  const [besitzeranzeige, setBesitzerAnzeige] = useState(false)
  const [neuerstandort, setNeuerStandort] = useState("kein");
  const [datenimport, setDatenimport] = useState(false);
  const [filename, setFilename] = useState("");
  const [standortanpassung, setStandortanpassung] = useState("");
  const [filebezeichnung, setFilebezeichnung] = useState("");
  const errorcB = () => {
    setIsLoading(false);
    setSpin(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  }
  const anfrageCB = (response) => {
    setSpin(false);
    setIsLoading(false);
    if (response.status === 200) {
      setNeuerStandort("kein")
      setMitarbeiter("");
      setBriefvorlage("");
      setZuordDat("");
      setBesitzer([]);
      setOpenIBox(false);
      setMsgBox(false);
      setBesitzerAnzeige(false);
      setBesitzerAnzeige(false);
      if (response.data.message) {
        if (response.data.message !== "ok") {
          showSuccessMessage(response.data.message)
        }
      }
      if (response.data.stamm) {
        setStamm(response.data.stamm)
      }
      if (response.data.fragen) {
        setFragen(response.data.fragen)
        setOpenIBox(true)
      }
      if (response.data.titel) {
        setIBoxTitle(response.data.titel)
      }
      if (response.data.nurbuttons) {
        setNurButtons(response.data.nurbuttons)
      } else {
        setNurButtons("")
      }
      if (response.data.besitzer) {
        setBesitzer(response.data.besitzer);
        setBesitzerAnzeige(true);
      }
      if (response.data.ansichtstatus) {
        setAnsichtstatus(response.data.ansichtstatus)
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const buttonAnfrage = (statement, button, key) => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "HRFIRE",
      "statement": statement,
      "button": button,
      "key": key,
      "ansichtstatus": ansichtstatus,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const Zuordnen = () => {
    setSpin(true)
    const payload = {
      "mandant": client,
      "program": "HRFIRE",
      "statement": "BUTTON_SPEICHERN",
      "button": "ZUORDNEN",
      "key": zeilenauswahl.current,
      "mitarbeiter": mitarbeiter,
      "zeitraum": zuorddat,
      "ansichtstatus": ansichtstatus,
      "briefvorlage": briefvorlage,
      "standort": neuerstandort,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const DokumentOeffnen = (dokumentenkey) => {
    console.log("Dokument öffnen")
    setSpin(true)
    const payload = {
      "mandant": client,
      "program": "HRFIRE",
      "statement": "DOKUMENT_ANZEIGEN",
      "key": zeilenauswahl.current,
      "Doknummer": dokumentenkey,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var fileName = dokumentenkey + ".pdf";
        var contentFile = response.data;
        const mimeType = response.headers['content-type'] || 'application/pdf'
        openFile(fileName, contentFile, mimeType);
        setSpin(false);
      })
      .catch(function (error) {
        console.log(error.response.data)
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        setSpin(false);
      })
  }
  const ZURUECKGEBEN = () => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "HRFIRE",
      "statement": "BUTTON_SPEICHERN",
      "button": "RUECKGABE",
      "key": zeilenauswahl.current,
      "zeitraum": zuorddat,
      "ansichtstatus": ansichtstatus,
      "briefvorlage": briefvorlage,
      "mitarbeiter": mitarbeiter,
      "standort": neuerstandort,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const inputBoxResult = (results) => {
    setIsLoading(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": "HRFIRE",
      "button": spaltenauswahl.current,
      "key": zeilenauswahl.current,
      "statement": "BUTTON_SPEICHERN",
      "antworten": results,
      "ansichtstatus": ansichtstatus,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const loeschen = (results) => {
    setSpin(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": "HRFIRE",
      "button": "LOESCHEN",
      "statement": "BUTTON_SPEICHERN",
      "key": zeilenauswahl.current,
      "ansichtstatus": ansichtstatus,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const DATEIUPLOAD = () => {
    setSpin(true);
    const payload = {
      "mandant": client,
      "program": "HRFIRE",
      "statement": "UPLOAD",
      "standortanpassung": standortanpassung,
    }
    const data = new FormData();
    data.append('file', filename);
    data.append('payload', JSON.stringify(payload));
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Mandant": client,
      "Program": "HRFIRE",
      "Statement": "UPLOAD",
    }
    axios.post(API_BASE_URL + 'upload', data, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var fileName = 'Übernahmeprotokoll.pdf';
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setSpin(false);
        setFilename("");
        setDatenimport(false);
      })
      .catch(function (error) {
        console.log(error);
        setSpin(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
    //*    apiRequest('POST', 'upload', data, headers, (r)=>uploadBack(r));
  }
  const messageBoxResult = (result) => {
    if (result === 'YES') {
      loeschen();
    }
    setMsgBox(false)
  }
  const buttonEnde = (spaltenkey) => {
    switch (spaltenkey) {
      case "ZUORNDEN":
        setDialog(false);
        Zuordnen();
        break;
      case "RUECKGABE":
        setRueckgabe(false);
        ZURUECKGEBEN();
        break;
      case "UPLOAD":
        var pruefung = false
        pruefung = filebezeichnung.toUpperCase().includes('.XLSX') || filebezeichnung.toUpperCase().includes('.CSV')
        if (pruefung) { DATEIUPLOAD() } else showErrorMessage(t("keine zulässige Datei"))
        break;
      default:
        break;
    }
  }
  const buttonClick = (spaltenkey, zeilenkey) => {
    switch (spaltenkey) {
      case "DETAILS":
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        setOpen(true)
        break;
      case "ZUORDNEN":
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        setDialog(true);
        break;
      case "RUECKGABE":
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        setRueckgabe(true);
        break;
      case "LOESCHEN":
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        setMsgBox(true);
        break;
      case "WECHSELN":
        setAuswahl("");
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        buttonAnfrage("BUTTON_START", spaltenkey, zeilenkey)
        break;
      case "ZUSATZ":
        setAuswahl("");
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        import_upload_Dateien(spaltenkey, zeilenkey)
        break;

      case "NEUANLAGE":
        zeilenauswahl.current = auswahl
        spaltenauswahl.current = spaltenkey
        buttonAnfrage("BUTTON_START", spaltenkey, auswahl)
        break;
      case "AUSWERTUNG":
        navigate("/interview/IV0003", { state: { programm: "HRFIRE" } })
        break;
      default:
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        buttonAnfrage("BUTTON_START", spaltenkey, zeilenkey)
        break;
    }
  }
  if (msgbox) {
    return (
      <MessageBox
        open={msgbox}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={"Soll das Firmeneigentum wirklich gelöscht werden?"}
        title={t("Löschbestätigung")}
        onClose={() => setMsgBox(false)}
      />
    )
  }
  const import_upload_Dateien = () => {
    setDatenimport(true);
  }
  const lade_dokument = (dokumentenkey) => {
    DokumentOeffnen(dokumentenkey)
  }
  const IboxButtonClick = (button, buttonkey) => {
    switch (button) {
      case "DMSDOK":
        spaltenauswahl.current = button
        lade_dokument(buttonkey);
        break;
      case "EDIT":
        spaltenauswahl.current = button
        buttonAnfrage("BUTTON_START", button, zeilenauswahl.current);
        break;
      case "DETAILS":
        spaltenauswahl.current = button
        buttonAnfrage("BUTTON_START", button, zeilenauswahl.current);
        break;
      case "ZUORDNEN":
        spaltenauswahl.current = button
        setDialog(true);
        setOpenIBox(false);
        break;
      case "RUECK":
        spaltenauswahl.current = button
        setRueckgabe(true);
        setOpenIBox(false);
        break;
      case "KAT_WECHSEL":
        spaltenauswahl.current = button
        setOpenIBox(false);
        buttonAnfrage("BUTTON_START", button, zeilenauswahl.current);
        break;
      case "LOESCHEN":
        spaltenauswahl.current = button
        setMsgBox(true);
        break;
      default:
        spaltenauswahl.current = button
        buttonAnfrage("BUTTON_START", button, zeilenauswahl.current)
        break;
    }
  }
  const dialogClose = () => {
    setDialog(false);
    setMitarbeiter("");
    setBriefvorlage("");
    setZuordDat("");
  }
  return (
    <Fragment>
      <MasterStamm accessToken={accessToken} client={client} pvxprogramm={"HRFIRE"} buttonClick={buttonClick} stamm={stamm} setStamm={setStamm} auswahl={auswahl}
        setAuswahl={setAuswahl} ansichtstatus={ansichtstatus} setAnsichtstatus={setAnsichtstatus} fenstergroße={12} keineAktionen={ansichtstatus !== "ARBEITNEHMER"}
        StartFilter={"0"}
      >
      </MasterStamm>
      <DetailsBox
        open={open}
        details={stamm?.[spaltenauswahl.current]?.[zeilenauswahl.current]}
        title={t("Detailansicht")}
        onClose={() => setOpen(false)}
        onBtnKlick={(dokumentenkey) => DokumentOeffnen(dokumentenkey)}
      />
      <ResponsiveDialog
        title={t("Zuordnung eines neuen Mitarbeiters")}
        open={dialog}
        setOpen={(o) => { dialogClose }}
      >
        <Box p={1}>
          <Typography>{t("Welchem Mitarbeiter soll die Ressource zugeordnet werden?")}</Typography>
          <Mitarbeiterauswahl programm={"HRFIRE"} client={client} onChange={(value) => setMitarbeiter(value)} />
        </Box>
        <Box p={1}>
          <Typography>{t("Wann wird das Firmeneigentum an die Person übergeben?")}</Typography>
          <DateTextField
            fullWidth
            onChange={(e) => setZuordDat(e.target.value)}
            value={zuorddat}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box p={1}>
          {stamm?.standort?.length > 0 &&
            <TextField
              select
              variant="outlined"
              label={t("Neuer Standort der Ressource?")}
              value={neuerstandort}
              onChange={(event) => setNeuerStandort(event.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            >
              {stamm?.standort?.map((filters) => {
                return (
                  <MenuItem value={filters.key}>{filters.bez}</MenuItem>
                )
              })
              }
            </TextField>
          }
        </Box>
        <Box p={1}>
          {stamm?.briefvorlagen?.length > 0 &&
            <TextField
              select
              variant="outlined"
              label={t("Briefvorlage")}
              value={briefvorlage}
              onChange={(event) => setBriefvorlage(event.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            >
              {stamm?.briefvorlagen?.map((filters) => {
                return (
                  <MenuItem value={filters.key}>{filters.bez}</MenuItem>
                )
              })
              }
            </TextField>
          }
        </Box>
        <Box pb={1} px={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Button fullWidth variant="contained" color="primary" onClick={() => buttonEnde("ZUORNDEN")} >{t("Zuordnen")}</Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button fullWidth color="primary" onClick={() => setDialog(false)} >{t("Abbrechen")}</Button>
          </Grid>
        </Grid>
        </Box>
      </ResponsiveDialog>
      <ResponsiveDialog
        title={t("Rückgabe")}
        open={rueckgabe}
        setOpen={(o) => { setRueckgabe(false) }}
      >
        <Box p={1}>
          <Typography>{t("Zu welchem Datum soll die Ressource zurückgegeben werden?")}</Typography>
          <DateTextField
            fullWidth
            onChange={(e) => setZuordDat(e.target.value)}
            value={zuorddat}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box p={1}>
          {stamm?.standort?.length > 0 &&
            <TextField
              select
              variant="outlined"
              label={t("Neuer Standort der Ressource?")}
              value={neuerstandort}
              onChange={(event) => setNeuerStandort(event.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            >
              {stamm?.standort?.map((filters) => {
                return (
                  <MenuItem value={filters.key}>{filters.bez}</MenuItem>
                )
              })
              }
            </TextField>
          }
        </Box>
        <Box p={1}>
          {stamm?.briefvorlagen?.length > 0 &&
            <TextField
              select
              variant="outlined"
              label={t("Briefvorlage")}
              value={briefvorlage}
              onChange={(event) => setBriefvorlage(event.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            >
              {stamm?.briefvorlagen?.map((filters) => {
                return (
                  <MenuItem value={filters.key}>{filters.bez}</MenuItem>
                )
              })
              }
            </TextField>
          }
        </Box>
        <Button variant="contained" color="primary" onClick={() => buttonEnde("RUECKGABE")} >{t("Zuordnen")}</Button>
        <Button color="primary" onClick={() => setRueckgabe(false)} >{t("Abbrechen")}</Button>
      </ResponsiveDialog>
      <InputBox
        open={openibox}
        handleResponse={inputBoxResult}
        fragen={fragen}
        title={iboxtitle}
        buttonClick={IboxButtonClick}
        onClose={() => setOpenIBox(false)}
        nurbuttons={nurbottons}
      />
      <ResponsiveDialog
        title={t("Besitzer-Historie")}
        open={besitzeranzeige}
        setOpen={(o) => { setBesitzerAnzeige(false) }}
      >
        <Fragment>
          <Box p={1}>
            <DynamicTable zeilen={besitzer?.tabelle} spalten={besitzer?.ueber} leertext={"keine Besitzer gefunden"} hoehe={700} buttonCb={(spaltenkey, zeilenkey) => buttonClick(spaltenkey, zeilenkey,)} minbreite={500} options={""} size={"small"} />
          </Box>
        </Fragment>
        <Button color="primary" onClick={() => setBesitzerAnzeige(false)} >{t("Schließen")}</Button>
      </ResponsiveDialog>

      <ResponsiveDialog
        title={t("Datei für Upload auswählen")}
        open={datenimport}
        setOpen={(o) => { setDatenimport(false) }}
        actionButton={
          <>
            <Box pl={1}>
              <Button variant="contained" color="primary" onClick={() => buttonEnde("UPLOAD")} >{t("Dateiupload")}</Button>
            </Box>
            <Box pl={1}>
              <Button color="primary" onClick={() => setDatenimport(false)} >{t("Abbrechen")}</Button>
            </Box>
          </>
        }
      >
        <TextField
          id="outlined-select-currency"
          size="big"
          select
          label={t("Soll der Standort auch übernommen bzw. angepasst werden?")}
          value={standortanpassung}
          onChange={(event) => setStandortanpassung(event.target.value)}
          helperText=""
        >
          {stamm?.standort?.map((filters) => {
            return (
              <MenuItem value={filters.key}>{filters.bez}</MenuItem>
            )
          })
          }
        </TextField>
        <TextField
          size="big"
          type="file"
          onChange={(e) => { setFilebezeichnung(e.target.value); setFilename(e.target.files[0]) }}
          helperText={t("Nur xlxs- oder csv-Dateien erlaubt")}
        />
      </ResponsiveDialog>
      {spin &&
        <FullPageSpinner />
      }
    </Fragment>
  )
}
export default HRRessourcen;
